import { TStoreState } from 'redux/types';

export const getEmVatList = (state: TStoreState) => state.emVat.emVatList;
export const getEmVatListLoading = (state: TStoreState) => state.emVat.emVatListLoading;
export const getCreateEmVatLoading = (state: TStoreState) => state.emVat.createEmVatLoading;
export const getUpdateEmVatLoading = (state: TStoreState) => state.emVat.updateEmVatLoading;
export const getDeleteEmVatLoading = (state: TStoreState) => state.emVat.deleteEmVatLoading;
